import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5466_9750)">
      <path
        d="M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z"
        fill="#151718"
      />
      <path
        d="M18.5781 5.422H5.42139V16.8768C5.42139 17.8164 6.1831 18.5781 7.12273 18.5781H9.033V9.03383H16.6877C17.7317 9.03383 18.5781 8.18748 18.5781 7.14345V5.422Z"
        fill="white"
      />
      <path
        d="M16.9981 9.8127H9.84239V17.4446C9.84239 18.0706 10.3512 18.5781 10.8622 18.5781H11.9957V12.0301H15.9699C16.5378 12.0301 16.9981 11.6552 16.9981 10.9596V9.8127Z"
        fill="#687076"
      />
    </g>
    <defs>
      <clipPath id="clip0_5466_9750">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(-0.000488281)"
        />
      </clipPath>
    </defs>
  </svg>
)
